<template>
  <div class="page-menu3-wrap style-1">
    <div class="themesflat-container">
      <div class="row">
        <!-- Loop through each category -->
        <div class="col-lg-6" v-for="(item, index) in menuItems" :key="index">
          <div class="menu-wrap left image-before">
            <!-- Category Name -->
            <div class="heading-section text-center">
              <div class="main">{{ item.category.name }}</div>
              <div class="divider"><div></div></div>
            </div>

            <!-- Category Products -->
            <div
              class="wg-menu-item relative w-full"
              v-for="(productWrapper, pIndex) in visibleProducts(item)"
              :key="pIndex"
            >
              <!-- Name + price row -->
              <div class="flex items-center justify-between w-full">
                <div class="name font-semibold text-lg">
                  {{ productWrapper.product.name }}
                </div>

                <div class="line flex-1 mx-2"></div>

                <div class="price text-gray-700 whitespace-nowrap">
                  €{{ Number(productWrapper.product.price || 0).toFixed(2) }}
                </div>
              </div>

              <!-- Short description -->
              <p class="text-sm text-gray-500 mt-1" v-if="productWrapper.product.description">
                {{ truncate(productWrapper.product.description, 45) }}
              </p>

              <!-- FULL WIDTH hover description -->
              <div class="hover-description" v-if="productWrapper.product.description">
                {{ productWrapper.product.description }}
              </div>
            </div>

            <!-- Show More / Show Less Button -->
            <a
              class="button-two-line"
              v-if="item.products.length > 10"
              @click="toggleShowMore(index)"
              >{{ item.showAll ? "Show less" : "Show more" }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "BannerPageComponent",
  data() {
    return {
      menuItems: [],
      langStore,
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchMenu();
    },
  },

  mounted() {
    this.fetchMenu();
  },

  methods: {
    fetchMenu() {
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/api/menu-items`, {
          params: { lang: this.langStore.lang },
        })
        .then((response) => {
          // Ensure response is an array of categories
          const data = Array.isArray(response.data)
            ? response.data
            : [response.data];

          // Add showAll property to each category
          this.menuItems = data.map((item) => ({
            ...item,
            showAll: false,
          }));
        })
        .catch((error) => {
          console.error("There was an error fetching the data:", error);
        });
    },

    visibleProducts(item) {
      // If "showAll" is true, show all; else show first 15
      return item.showAll ? item.products : item.products.slice(0, 10);
    },
    toggleShowMore(index) {
      this.menuItems[index].showAll = !this.menuItems[index].showAll;
    },
    truncate(text, length) {
      if (!text || typeof text !== "string") return "";
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
  },
};
</script>

<style scoped>
.button-two-line {
  cursor: pointer;
}

.product-description {
  cursor: pointer;
}

.wg-menu-item .line {
  border-bottom: 1px solid #efbed4;
}

.heading-section .main {
  font-size: 33px !important;
  margin-bottom: 10px !important;
}

.page-menu3-wrap .menu-wrap.left {
  margin-bottom: 60px !important;
}

.wg-menu-item {
  position: relative;
}

.hover-description {
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%; /* FULL col-6 width */
  padding: 15px 30px;
  background: #2e7288;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  opacity: 0;
  visibility: hidden;
  transition: 0.3s ease;
  z-index: 10;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 25px;
}

.wg-menu-item:hover .hover-description {
  opacity: 1;
  visibility: visible;
}
</style>
